/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/

/* Javascript - Show cart drawer when product added to cart */
document.addEventListener('theme:cart:popdown', (e) => {
  const listener = (e) => {
    document.querySelector('[data-drawer="drawer-cart"]').dispatchEvent(
      new CustomEvent('theme:drawer:open', {
        bubbles: false,
      })
    );
    document.removeEventListener('theme:cart:change', listener);
  };
  document.addEventListener('theme:cart:change', listener);
});
/* end */

(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page

      compare = document.getElementById("amount-off");
      compare_price_2 = variant.compare_at_price/100
      compare.textContent = "$" + compare_price_2.toFixed(2);
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator

      // Find the DIV element by class name

        const subtotal = cart.total_price / 100;

      //  let countString = "No FREE";

      //  // Determine gift count based on subtotal
      //  if (subtotal >= 200 && subtotal < 500) {
      //    countString = "1 FREE (FOREVER HEART CHARM)";
      //  } else if (subtotal >= 500 ) {
      //    countString = "2 FREE (CHARM & BEADED BRACELET)";
      //  } 

      //const p = document.querySelector('.cart__message.cart__message--custom p');
      //if (p) {
      //  p.innerHTML = "<strong>FREE GIFTS!! - </strong>up to 2 FREE items w code FREEGIFT only." + `<br>[${countString} gifts achieved so far!] see <a href="/">DETAILS</a>`;
      //  //p.innerHTML = `Cyber Monday Sale Running Now up to 50% OFF - <a href="/">DETAILS</a><br><strong>& FREE JEWELRY!! - </strong>up to 4 FREE items w code FREEGIFT only.` + `<br>[${countString} gifts achieved so far!] see <a href="/">DETAILS</a>`;
      //}      

    }
  });

  
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // // Debounced scroll listeners.  Up and down only fire on direction changes
  //// These events are useful for creating sticky elements and popups.
  //document.addEventListener('theme:scroll', e => { console.log(e); });
  //document.addEventListener('theme:scroll:up', e => { console.log(e); });
  //document.addEventListener('theme:scroll:down', e => { console.log(e); });

  //// Debounced resize listener to bundle changes that trigger document reflow
  //document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();